import React from "react";

const ZapierIntegration = () => {
  const userEmail = localStorage.getItem("userEmail");

  const webhookURL = `https://crm-backend-69yp.onrender.com/webhook/zapier`; // esempio: https://mio-crm.it/webhook/zapier
  const examplePayload = {
    nome: "Mario Rossi",
    email: "mario@example.com",
    telefono: "+393331234567",
    note: "Lead da Facebook",
    stato: "Lead",
    tag: ["Facebook", "Zap"],
    email_utente: userEmail || "INSERISCI_LA_TUA_EMAIL"
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("✅ Copiato negli appunti!");
  };

  return (
    <div className="p-6 bg-white rounded shadow-md">
      <h2 className="text-2xl font-bold mb-4">🤖 Integrazione con Zapier</h2>

      <p className="mb-2">
        Usa questo link come destinazione del tuo Webhook in Zapier:
      </p>

      <div className="flex items-center mb-4">
        <input
          className="border p-2 w-full mr-2"
          value={webhookURL}
          readOnly
        />
        <button
          onClick={() => copyToClipboard(webhookURL)}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Copia
        </button>
      </div>

      <p className="mb-2">Ecco il payload di esempio da usare nel Webhook:</p>

      <textarea
        className="border p-2 w-full mb-4 text-sm font-mono"
        rows={10}
        value={JSON.stringify(examplePayload, null, 2)}
        readOnly
      />

      <button
        onClick={() => copyToClipboard(JSON.stringify(examplePayload, null, 2))}
        className="bg-blue-500 text-white px-4 py-2 rounded"
      >
        Copia payload
      </button>

      <div className="mt-6">
        <h3 className="text-xl font-semibold mb-2">📌 Istruzioni Zapier</h3>
        <ol className="list-decimal pl-4 space-y-2">
          <li>Crea un nuovo Zap su <a href="https://zapier.com" target="_blank" rel="noreferrer" className="text-blue-600 underline">Zapier.com</a>.</li>
          <li>Come trigger scegli “Webhook by Zapier” e seleziona “Catch Hook”.</li>
          <li>Inserisci l’URL fornito sopra come endpoint.</li>
          <li>Usa il payload d’esempio per testare il webhook.</li>
          <li>Collega l’azione che preferisci (es: Facebook Lead Ads, Google Form, ecc).</li>
        </ol>
      </div>
    </div>
  );
};

export default ZapierIntegration;
